__turbopack_context__.v({
  "root": "VisuallyHidden-module__2b4UpG__root",
});
